__turbopack_context__.v({
  "accordionSlideOverwrite": "eventControls-module-scss-module__usnRyq__accordionSlideOverwrite",
  "active": "eventControls-module-scss-module__usnRyq__active",
  "controls": "eventControls-module-scss-module__usnRyq__controls",
  "count": "eventControls-module-scss-module__usnRyq__count",
  "fadeIn": "eventControls-module-scss-module__usnRyq__fadeIn",
  "fadeOut": "eventControls-module-scss-module__usnRyq__fadeOut",
  "scaleIn": "eventControls-module-scss-module__usnRyq__scaleIn",
  "scaleOut": "eventControls-module-scss-module__usnRyq__scaleOut",
  "toggleButton": "eventControls-module-scss-module__usnRyq__toggleButton",
  "toggleButtonLeft": "eventControls-module-scss-module__usnRyq__toggleButtonLeft",
  "toggleButtonRight": "eventControls-module-scss-module__usnRyq__toggleButtonRight",
  "toggleContainer": "eventControls-module-scss-module__usnRyq__toggleContainer",
  "zoomIn": "eventControls-module-scss-module__usnRyq__zoomIn",
  "zoomOut": "eventControls-module-scss-module__usnRyq__zoomOut",
});
